import React, { useState } from "react";
import {
  Accordion,
  Card,
  Button,
  Form,
  Offcanvas,
  CloseButton,
} from "react-bootstrap";
import SubSection1 from "./SubSection1";
import { Select } from "antd";
import SubSection2 from "./SubSection2";
import SubSection3 from "./SubSection3";
import { useCustomer } from "../actionables/store";
import SubSection4 from "./SubSection4";
import BlueTick from "assets/svgs/blue_tick";
import Tick from "assets/svgs/tick";
import SaveFeedBack from "./SaveFeedBack";
import Comments from "./Comments";
import moment from "moment";

function SlotBookingDisposition({
  orderCount,
  data,
  week,
  id,
  bookingId,
  list,
  customerId,
  setData,
  setBooking,
  orders,
}) {
  const [show, setShow] = useState(false);

  const [hasApp, setHasApp] = useState("");
  const [usesBAH, setUsesBAH] = useState("");
  const [followsDiet, setFollowsDiet] = useState("");
  const { customerData } = useCustomer();
  const buttonStyle =
    "border rounded-2 mb-0 p-2 cursor-pointer option-hover flex-1 text-center";
  const selected =
    "border rounded-2 mb-0 p-2 cursor-pointer bg-primary text-white flex-1 text-center";
  const formRow = "d-flex gap-3";
  const callResponseOptions = [
    { value: "answered", label: "Answered" },
    { value: "unanswered", label: "Not Answered" },
    { value: "languageIssue", label: "Language Issue" },
  ];

  const [formData, setFormData] = useState({
    comments: null,
    callResponse: null,
    tabletsUsage: false,
    suppliments: false,
    timelineSupplements: false,
    customerSerum: null,
    explainedApplication: null,
    expectationSetting: false,
    usageOfOil: false,
    hairShedding: false,
    explainedScience: false,
    uploadScalpPic: false,
    probingDone: false,
    medicalEscalation: false,
    scienceBehindWorking: false,
    hairFallTakingPlace: false,
    noResultInHairGrowth: false,
    explainedScienceRegrowth: false,
    explainedPostives: false,
    explainedScienceBehaindWorking: false,
    probeRegularity: false,
    scabiesMonth: null,
    medicalEscalationProblem: false,
    dandruffRelated: false,
    dandruffRelatedStatus: null,
    gutCondition: false,
    cxToStop: false,
    gutConditionStatus: null,
    reiteratedMonthlyGoals: false,
    regularUsage: "",
    newSupplementAdded: false,
    explanation: "",
    sleepOrStress: false,
    sleepOrStressStatus: null,
    reorder: false,
    probedRegularityUsage: "",
    understoodReasons: false,
    importanceOfRegularity: false,
    tookUpdatesOnResults: false,
    explainedTheMonthlyGoals: false,
    placedTheOrder: false,
    deliveryRelatedConcern: false,
    maintenanceCall: false,
    apologisedRaisedTicket: false,
    referredToSOP: false,
    needToRaiseTicket: false,
  });

  const renderedComponents = [
    { name: "callResponse", value: formData.callResponse },
  ];

  const handleSelect = (category, value) => {
    switch (category) {
      case "hasApp":
        setHasApp(value);
        setUsesBAH("");
        setFollowsDiet("");
        break;
      case "usesBAH":
        setUsesBAH(value);
        break;
      case "followsDiet":
        setFollowsDiet(value);
        break;
      default:
        break;
    }
  };

  const renderHealthCheckContent = () => {
    if (hasApp === "yes") {
      return (
        <div>
          <Form.Group controlId="formHasApp">
            <Form.Label className="text-primary">Do you use BAH? </Form.Label>
            <Form.Select
              value={usesBAH}
              onChange={(e) => handleSelect("usesBAH", e.target.value)}
            >
              <option value="">Select</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </Form.Select>
          </Form.Group>

          {usesBAH === "yes" ? (
            <p>
              Thank you for using BAH! Please log daily and enjoy the benefits
              of tracking your health.
            </p>
          ) : (
            <p>
              Explore the benefits of reward coins by logging daily and
              maintaining a healthy lifestyle.
            </p>
          )}
          <Form.Group controlId="formFollowsDiet">
            <Form.Label className="text-primary">
              Do you follow a diet?
            </Form.Label>
            <Form.Select
              value={followsDiet}
              onChange={(e) => handleSelect("followsDiet", e.target.value)}
            >
              <option value="">Select</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </Form.Select>
          </Form.Group>

          {followsDiet === "yes" ? (
            <p>
              Great! Please log your diet daily to maximize the benefits of a
              healthy lifestyle.
            </p>
          ) : followsDiet === "no" ? (
            <p>
              Understand the reasons for not following a diet and provide
              flexible hacks to help you get started.
            </p>
          ) : (
            <div></div>
          )}
        </div>
      );
    } else {
      return (
        <p>
          Prompt to download the app and explain the benefits and features in a
          jist
        </p>
      );
    }
  };

  // const monthsIntoTreatment = customerData.orders.length;
  const isoFormattedDate = moment().toISOString();

  const deliveredOrders = customerData.orders.filter(
    (item) => item?.delivery_date !== null && item?.delivery_date !== "null"
  );

  const singleOrderCount = deliveredOrders.filter(
    (order, i) => order?.is_single_order === true
  );

  const normalOrders = customerData.orders.filter(
    (item) => item?.is_bulk_order === false && item?.is_single_order === false
  );

  const getDeliveredDate = deliveredOrders && deliveredOrders.length > 0 ? deliveredOrders[0]?.delivery_date : new Date();
  // Parse delivery date string into a moment object
  const deliveredDate = moment(getDeliveredDate);
  // Calculate the difference in days
  const differenceInDays = moment(isoFormattedDate).diff(deliveredDate, "days");

  let validOrderCount =
  (Math.round(differenceInDays / 30) + normalOrders?.length || 0) -
  singleOrderCount?.length;
  
  const handleShow = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    // setOrderDisplayId(null);
  };

  const handleCallResponse = (response) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      callResponse: response,
    }));
  };

  const pushComponent = (name, value) => {
    renderedComponents.push({ name, value });
  };

  return (
    <>
      {list ? (
        <div className="cursor-pointer" onClick={() => handleShow("lg-down")}>
          <BlueTick />
        </div>
      ) : (
        <Button className="flex-1" onClick={() => handleShow("lg-down")}>
          <Tick />
        </Button>
      )}
      <Offcanvas
        show={show}
        placement={"end"}
        style={{ width: "40%" }}
        onHide={handleClose}
      >
        <Offcanvas.Header CloseButton>
          <Offcanvas.Title>Add Feedback</Offcanvas.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={handleClose}
          />
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            {" "}
            <div className={formRow}>
              {callResponseOptions.map((option) => (
                <p
                  key={option.value}
                  className={
                    formData.callResponse === option.value
                      ? selected
                      : buttonStyle
                  }
                  onClick={() => handleCallResponse(option.value)}
                >
                  <span className="fw-bold "> {option.label}</span>
                </p>
              ))}
            </div>
            {formData?.callResponse == "answered" ? (
              <div className="mt-2">
                <h2>Call Purpose</h2>
                <SubSection1
                  slotBookingData={formData}
                  setSlotBookingData={setFormData}
                />{" "}
                <br />
                <SubSection2
                  slotBookingData={formData}
                  setSlotBookingData={setFormData}
                  deliveredOrders={deliveredOrders}
                />{" "}
                <br />
                <SubSection3
                  slotBookingData={formData}
                  setSlotBookingData={setFormData}
                  validOrderCount={validOrderCount}
                />{" "}
                <br />
                <SubSection4
                  slotBookingData={formData}
                  setSlotBookingData={setFormData}
                />
                <h2>General catchup</h2>
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>CX has APP</Accordion.Header>
                    <Accordion.Body>
                      <Form.Group controlId="formHasAppAccordion">
                        <Form.Label className="text-primary">
                          Do you have the app?
                        </Form.Label>
                        <Form.Select
                          value={hasApp}
                          onChange={(e) =>
                            handleSelect("hasApp", e.target.value)
                          }
                        >
                          <option value="">Select</option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </Form.Select>
                      </Form.Group>
                      {renderHealthCheckContent()}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                <div className="mt-3">
                  <Comments
                    setFormData={setFormData}
                    length={formData?.comments?.length}
                  />
                  {pushComponent("comments", formData.comments)}
                </div>
              </div>
            ) : null}
          </div>
          {formData?.callResponse === "answered" ||
          // formData?.comments &&
          // formData?.language &&
          // formData?.crmMentionedTime &&
          // formData?.healthCondition &&
          // formData?.prevSupplementConsumed) ||
          ["unanswered", "languageIssue"].includes(formData?.callResponse) ? (
            <SaveFeedBack
              setShow={setShow}
              bookingId={bookingId}
              week={week}
              formData={formData}
              selected={selected}
              buttonStyle={buttonStyle}
              formRow={formRow}
              renderedComponents={renderedComponents}
              id={id}
              customerId={customerId}
              setData={setData}
              setBooking={setBooking}
            />
          ) : (
            <div className="text-danger fw-bold mt-2 text-center">
              Field with star is mandatory.
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default SlotBookingDisposition;
